import { render, staticRenderFns } from "./importDetail.vue?vue&type=template&id=4ac17e72&scoped=true&"
import script from "./importDetail.vue?vue&type=script&lang=js&"
export * from "./importDetail.vue?vue&type=script&lang=js&"
import style0 from "./importDetail.vue?vue&type=style&index=0&id=4ac17e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac17e72",
  null
  
)

export default component.exports